<template>
  <div
    @click="toggleDropdown"
    class="flex flex-nowrap items-center bg-gray-300 rounded-full border border-gray-300 py-[4px] pl-[12px] pr-[8px] text-sm font-medium text-university-primary gap-2 cursor-pointer"
  >
    <span>{{ label }}</span>
    <div
      class="flex justify-center items-center min-w-[20px] h-[20px] rounded-full text-sm text-white bg-university-primary"
    >
      {{ refinement.refinements.length }}
    </div>
    <search-chevron :height="'5'" :width="'10'" :rotate-direction="expanded ? 'down' : 'right'" />
  </div>
  <overlay-panel ref="op" class="bg-white z-9999 rounded-lg">
    <div class="p-3 min-width-[200px] max-h-[300px] overflow-y-auto">
      <checkbox-filter :filterAttribute="refinement.attribute" />
    </div>
  </overlay-panel>
</template>
<script setup>
import { ref, computed } from "vue";
import CheckboxFilter from "./CheckboxFilter.vue";
import SearchChevron from "@/components/svg-icons/SearchChevron.vue";
import OverlayPanel from "primevue/overlaypanel";
import { useRegisteredFacets } from "../composables/useRegisteredFacets";

const props = defineProps({
  refinement: {
    type: Object,
  },
});

const { currentFacets } = useRegisteredFacets();

const op = ref();
const expanded = ref(false);

const toggleDropdown = (event) => {
  if (!op.value) {
    return;
  }
  op.value.toggle(event);
  expanded.value = !expanded.value;
};

const label = computed(() => {
  return (
    currentFacets.value
      .filter((facet) => facet.attribute === props.refinement.attribute)
      .map((facet) => facet.title)[0] ?? ""
  );
});
</script>
<style scoped>
/* Scrollbar Width */
::-webkit-scrollbar {
  width: 6px;
}

/* Scrollbar Track */
::-webkit-scrollbar-track {
  background-color: #fafbff; /* Tailwind's bg-gray-100 */
}

/* Scrollbar Thumb */
::-webkit-scrollbar-thumb {
  background-color: #7a7a7a; /* Tailwind's bg-blue-500 */
  border-radius: 9999px; /* Tailwind's rounded-full */
}

/* Scrollbar Thumb on Hover */
::-webkit-scrollbar-thumb:hover {
  background-color: #7a7a7a; /* Tailwind's bg-blue-700 */
}
</style>
